var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.71,10.29,16,11v2l-.29.71-8,8L7,22H5l-.71-.29-2-2L2,19V17l.29-.71,3-3,1.42,1.42L4,17.41v1.18L5.41,20H6.59L14,12.59V11.41l-.71-.7,1.42-1.42Zm6-6-2-2L19,2H17l-.71.29-8,8L8,11v2l.29.71,1,1,1.42-1.42-.71-.7V11.41L17.41,4h1.18L20,5.41V6.59l-2.71,2.7,1.42,1.42,3-3L22,7V5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLink);
export default __webpack_public_path__ + "static/1787897133/media/icon-link.8b218be4929b6612d9c57eb2857a024d.svg";
export { ForwardRef as ReactComponent };